import mixpanel from 'mixpanel-browser';
import { config } from '../config/environment';

const enabled = Boolean(config.mixpanelToken);

// Initialize Mixpanel with project token
// Autocapture and Session Replay are enabled
if (enabled) {
  mixpanel.init(config.mixpanelToken, {
    debug: import.meta.env.DEV,
    track_pageview: true,
    persistence: 'localStorage',
    autocapture: true,
    record_sessions_percent: 0,
  });
}

const analytics = {
  identify(userId: string) {
    if (enabled) mixpanel.identify(userId);
  },
  people: {
    set(properties: Record<string, unknown>) {
      if (enabled) mixpanel.people.set(properties);
    },
  },
  reset() {
    if (enabled) mixpanel.reset();
  },
  track(eventName: string, properties?: Record<string, unknown>) {
    if (enabled) mixpanel.track(eventName, properties);
  },
};

export default analytics;
